// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PBIDashboard_dashboardContaier__RZlTT {
    padding: 5% 10% 0% 10%;
    /* margin-top: 8%; */

}

.PBIDashboard_iframeView__qK-5r {
    width: 1000px;
    height: 450px;
}

@media screen and (min-width: 350px) and (max-width: 500px) {
    .PBIDashboard_dashboardContaier__RZlTT {
        margin-top: 20%;
        overflow-y: scroll;
        max-width: 400px;
    }

    .PBIDashboard_responsiveIframe__kmLBQ {

        width: 1000px;
        height: 500px;
        border: none;
    }

    .PBIDashboard_iframeView__qK-5r {
        width: 800px;
        height: 500px;
    }

}

@media screen and (min-width: 500px) and (max-width: 770px) {
    .PBIDashboard_container__4k9tS {
        position: relative;
        width: 100%;
        overflow: hidden;
        padding-top: 56.25%;
        /* 16:9 Aspect Ratio */
    }

    .PBIDashboard_responsiveIframe__kmLBQ {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        border: none;
    }

}



@media screen and (min-width: 1500px) {
    .PBIDashboard_iframeView__qK-5r {
        width: 1500px;
        height: 800px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Common/Components/PBIDashboard/PBIDashboard.module.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,oBAAoB;;AAExB;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI;QACI,eAAe;QACf,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;;QAEI,aAAa;QACb,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;AAEJ;;AAEA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,SAAS;QACT,QAAQ;QACR,WAAW;QACX,YAAY;QACZ,YAAY;IAChB;;AAEJ;;;;AAIA;IACI;QACI,aAAa;QACb,aAAa;IACjB;AACJ","sourcesContent":[".dashboardContaier {\n    padding: 5% 10% 0% 10%;\n    /* margin-top: 8%; */\n\n}\n\n.iframeView {\n    width: 1000px;\n    height: 450px;\n}\n\n@media screen and (min-width: 350px) and (max-width: 500px) {\n    .dashboardContaier {\n        margin-top: 20%;\n        overflow-y: scroll;\n        max-width: 400px;\n    }\n\n    .responsiveIframe {\n\n        width: 1000px;\n        height: 500px;\n        border: none;\n    }\n\n    .iframeView {\n        width: 800px;\n        height: 500px;\n    }\n\n}\n\n@media screen and (min-width: 500px) and (max-width: 770px) {\n    .container {\n        position: relative;\n        width: 100%;\n        overflow: hidden;\n        padding-top: 56.25%;\n        /* 16:9 Aspect Ratio */\n    }\n\n    .responsiveIframe {\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        width: 100%;\n        height: 100%;\n        border: none;\n    }\n\n}\n\n\n\n@media screen and (min-width: 1500px) {\n    .iframeView {\n        width: 1500px;\n        height: 800px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboardContaier": `PBIDashboard_dashboardContaier__RZlTT`,
	"iframeView": `PBIDashboard_iframeView__qK-5r`,
	"responsiveIframe": `PBIDashboard_responsiveIframe__kmLBQ`,
	"container": `PBIDashboard_container__4k9tS`
};
export default ___CSS_LOADER_EXPORT___;
